import type { App, InjectionKey } from 'vue'

import type { TenantConfig } from '@/config/app/types'

/**
 * Ключ для инъекции конфигурации приложения
 */
export const APP_CONFIG_KEY: InjectionKey<TenantConfig> = Symbol('app-config')

/**
 * Получает конфигурацию из экземпляра приложения (для использования в плагинах)
 * @param app - экземпляр Vue приложения
 * @returns конфигурация тенанта
 * @throws Error если конфигурация не найдена
 */
export function getAppConfig(app: App): TenantConfig {
  const config = app.config.globalProperties.$appConfig as TenantConfig | undefined

  if (!config) {
    throw new Error('App configuration not found. Make sure to set it in globalProperties before installing plugins.')
  }

  return config
}

/**
 * Composable для получения конфигурации приложения (для использования в компонентах)
 * @returns текущая конфигурация тенанта
 * @throws Error если конфигурация не была предоставлена через provide
 */
export function useAppConfig(): TenantConfig {
  const config = inject(APP_CONFIG_KEY)

  if (!config) {
    throw new Error('App configuration not found. Make sure to provide it using APP_CONFIG_KEY in your app setup.')
  }

  return config
}
